module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', [_c('v-flex', [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-card-text', [
    [_c('v-form', [_c('v-text-field', {
      attrs: {
        "label": "Title",
        "required": "",
        "id": "title"
      },
      model: {
        value: (_vm.title),
        callback: function($$v) {
          _vm.title = $$v
        },
        expression: "title"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Description",
        "required": "",
        "id": "desc"
      },
      model: {
        value: (_vm.description),
        callback: function($$v) {
          _vm.description = $$v
        },
        expression: "description"
      }
    })], 1), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Turn on Dates"
      },
      model: {
        value: (_vm.switch1),
        callback: function($$v) {
          _vm.switch1 = $$v
        },
        expression: "switch1"
      }
    }), _vm._v(" "), _c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch1),
        expression: "switch1"
      }],
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "120%"
      }
    }, [_vm._v(" Start Date ")]), _vm._v(" "), _c('v-date-picker', {
      model: {
        value: (_vm.date1),
        callback: function($$v) {
          _vm.date1 = $$v
        },
        expression: "date1"
      }
    })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch1),
        expression: "switch1"
      }],
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "120%"
      }
    }, [_vm._v(" End Date ")]), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "allowed-dates": _vm.selectableDays
      },
      model: {
        value: (_vm.date2),
        callback: function($$v) {
          _vm.date2 = $$v
        },
        expression: "date2"
      }
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Add Team Members"
      },
      model: {
        value: (_vm.switch3),
        callback: function($$v) {
          _vm.switch3 = $$v
        },
        expression: "switch3"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch3),
        expression: "switch3"
      }]
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "disabled": _vm.isUpdating,
        "items": _vm.filteredUsers,
        "box": "",
        "chips": "",
        "color": "blue-grey lighten-2",
        "label": "Select Team Members",
        "item-text": "name",
        "item-value": "id",
        "cache-items": "",
        "multiple": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected,
              "close": ""
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item.id)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.photoURL
            }
          })]), _vm._v("\n                  " + _vm._s(data.item.name) + "\n                ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.photoURL
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.name)
            }
          }), _vm._v(" "), _c('v-list-tile-sub-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.group)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1)], 1)]
  ], 2), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.draft
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.Cancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10bddd69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Projectdiag.vue
// module id = 57
// module chunks = 2 9